<template>
  <div class="main">
    <c-panel title="Rota" titleIcon="fas fa-map-signs">
      <form-rota :paramId="id" @onSubmitRota="afterSubmit"></form-rota>
    </c-panel>
  </div>
</template>

<script>
import formRota from "./form"

export default {
  components: { formRota },
  computed: {
    id () { return this.$route.params.id }
  },
  methods: {
    afterSubmit () { this.$router.push('/admin/transporte/rota') }
  }
}
</script>

